import { useState, useEffect } from "react";

import styled, { css } from "styled-components";

import device from "src/styles/device";
// import { UseUpload } from "src/context/UploadProductContext";
import {
  IconCalculationArea,
  IconArrowDown,
  IconCart,
  IconDownload,
  IconShare,
  IconCopyLink,
  IconSampleRequest,
  IconCompare,
  IconInstaller,
  IconMaterialAlbumNew,
  IconReduceButton,
  IconAddButton,
  IconTel,
  IconLine,
  IconWarning,
  IconDiscountTag,
  IconExclusiveDealBlack,
} from "src/icons";

const DivProductDetail = styled.div`
  width: 100%;
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  margin-bottom: 60px;
`;

const DivImageMain = styled.div`
  width: 47%;
  margin-right: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageMain = styled.div`
  border-radius: 16px;
  width: 100%;
  height: 100%;
  max-width: 480px;
  max-height: 428px;
  position: absolute;
  top: 0;
  display: none;

  .plus-video {
    visibility: visible;
  }

  &:hover {
    .plus-detail {
      visibility: visible;
    }
  }

  &:first-child {
    display: block;
  }
`;

const MainImageStyled = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  border-radius: 3px;
  /* object-fit: contain; */
  object-position: center;
  display: none;
  margin: 0 auto;

  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;

  &:hover {
    .plus-detail {
      visibility: visible;
    }
  }

  &:first-child {
    display: block;
  }
`;

const DivVideo = styled.div`
  opacity: 0.95;
  background: #363638;
  width: 100%;
  border-radius: 3px;
  height: 100%;
  object-fit: contain;
  object-position: center;
  position: absolute;
  top: 0;
  cursor: pointer;
  display: none;
  margin-bottom: 30px;
  .plus-video {
    visibility: visible;
  }

  div:nth-child(2) {
    visibility: visible;
    opacity: 1;
  }
  &:hover {
    .plus-detail {
      visibility: visible;
    }
  }

  &:first-child {
    display: block;
  }
`;

const VideoMain = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const DivImageSecondary = styled.div`
  width: 23.87%;
  height: 100%;
  cursor: pointer;
  position: relative;
  margin-right: 2.8%;
  display: inline-block;
  border-radius: 8px;

  :last-child {
    margin-right: 0;
  }

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 1px solid rgba(225, 59, 48, 0.5);
  }
`;

const ImageSecondary = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  position: absolute;
  top: 0;

  &:hover {
    opacity: 0.8;
  }
`;

const WrapperBlackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  border-radius: 3px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
`;

const VideoSecondary = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  position: absolute;
  top: 0;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const BGCollection = styled.div`
  background-color: #252525;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  border-radius: 3px;

  &.active {
    border: 2px solid #707070;
  }
`;

const PlayVideoSecondaryOnVideo = styled.div`
  margin: auto;
  cursor: pointer;
  width: 10.89%;
  padding-top: 13.04%;
  cursor: pointer;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/icon/icon_play_or.png");
  background-size: 100% 100%;
  z-index: 100;
`;

const DivDescription = styled.div`
  width: 50%;
  height: fit-content;
  border-radius: 16px;
  padding: 25px 30px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px;
`;

const WrapperImageSecondary = styled.div`
  max-width: 100%;
  padding: 0;
`;

const ProductDetailWrapper = styled.div`
  display: block;
`;

const DivFlex = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 16px;
`;

const ProductPrice3 = styled.span`
  font-size: 0.875rem;
  color: #381c1c;
  font-weight: 300;
  display: block;
  margin: auto 8px auto 0;
`;

const ProductPriceSpecial = styled.span`
  text-decoration: line-through rgb(108, 108, 112);
  display: block;
  margin: 10px 0px 0px;
  font-family: Prompt;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 21px;
  color: rgb(108, 108, 112);
`;

const ProductPrice = styled.span`
  font-size: 1.5rem;
  color: rgb(225, 59, 48);
  display: block;
  font-weight: 600;
  line-height: 1;
  font-family: Prompt;
`;

const ProductPrice2 = styled.span`
  font-size: 0.875rem;
  color: rgb(225, 59, 48);
  font-weight: 450;
  display: flex;
  margin: 0px 10px;
  font-family: Prompt;
  height: 32px;
  align-items: flex-end;
`;

const LabelIsInstaller = styled.div`
  width: 100px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 6px;
`;

const WrapperIconInstaller = styled.div`
  width: 35px;
  height: 25px;
  margin-right: 5px;
  position: relative;
  display: flex;
`;

const TextHeadInstall = styled.span`
  font-family: "Prompt";
  font-weight: 600;
  font-size: 0.875rem;
  color: #e13b30;
  display: block;
  line-height: 1;

  @media ${device.mobileL} {
    font-size: 0.6875rem;
  }
`;

const TextDescInstall = styled.span`
  font-family: "Prompt";
  font-style: "italic";
  font-weight: 400;
  font-size: 0.625rem;
  color: #252525;
  display: block;
  line-height: 1;

  @media ${device.mobileL} {
    font-size: 0.4375rem;
  }
`;

const InputVolume = styled.input`
  width: 126px;
  min-width: 80px;
  max-width: 160px;
  height: 38px;
  padding: 8px 16px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(217, 217, 217);
  border-radius: 16px;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgb(37, 37, 37);
  margin: 0px 10px;
  cursor: pointer;
`;

const ButtonKeyword = styled.button`
  font-family: inherit;
  margin-right: 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  padding: 5px 10px;
  color: rgb(108, 108, 112);
  background-color: rgb(243, 241, 242);
  border: 1px solid rgb(243, 241, 242);
  font-size: 0.75rem;
`;

const WrapperProductName = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: relative;
  flex-direction: row;
`;

const WrapperProductCode = styled.div`
  height: auto;
  display: flex;
  margin: 5px 0px 0px;
  position: relative;
  flex-direction: row;
`;

const WrapperProductPrice = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-end;
  margin: 16px 0px 0px;
  position: relative;
  flex-direction: row;
`;

const WrapperPriceVat = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  margin: 8px 0px 15px;
  position: relative;
  flex-flow: wrap;
`;

const WrapperSpecialPrice = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  position: relative;
  flex-direction: row;
`;

const ProductName = styled.span`
  font-size: 1.25rem;
  font-weight: 500;
  /* text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap; */
  width: 65%;
`;

const ProductCode = styled.span`
  font-weight: 450;
  font-size: 0.875rem;
  color: rgb(108, 108, 112);
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const PriceVat = styled.span`
  font-size: 0.75rem;
  color: rgb(37, 37, 37);
  font-family: Prompt;
  font-weight: 450;
  line-height: 18px;
  width: 80%;
`;

const LineSectionDetail = styled.div`
  border-top: 1px solid rgb(217, 217, 217);
  margin: 16px 0px;
  display: block;
`;

const WrapperOptionsProduct = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  margin: 0px 0px 10px;
  position: relative;
  flex-direction: row;
`;

const OptionsProduct = styled.span`
  font-size: 0.875rem;
  display: block;
  font-weight: 600;
  line-height: 21px;
  color: rgb(37, 37, 37);
  min-width: 78px;
  /* position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-end; */
`;

const FeatureProduct = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const ProductOption = styled.div`
  border: ${({ isActive, isStock }) =>
    isActive && isStock
      ? "2px solid #F09D97"
      : !isActive && isStock
        ? `1px solid #D9D9D9`
        : isActive && !isStock
          ? "2px solid #D8D8DC"
          : "none"};
  color: ${({ isActive, isStock }) =>
    isActive && isStock
      ? `#E13B30`
      : !isActive && !isStock
        ? `#BCBCC0`
        : !isActive && isStock
          ? `#252525`
          : isActive && !isStock
            ? `#BCBCC0`
            : null};

  background: ${({ isActive, isStock }) =>
    isActive && isStock
      ? `#F7CECB`
      : !isActive && !isStock
        ? `#F3F1F2`
        : !isActive && isStock
          ? `#FFFF`
          : isActive && !isStock
            ? `#F3F1F2`
            : null};

  display: flex;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: center;
  margin: 0 16px 16px 0;
  cursor: pointer;
`;

const RowDescription = styled.div`
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ height }) => (height ? height : "auto")};
  display: ${({ isMobile }) => (isMobile ? "none" : "flex")};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  position: relative;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "row"};
  border-top: ${({ borderTop }) => borderTop};
  border-bottom: ${({ borderBottom }) => borderBottom};
  cursor: ${({ cursor }) => cursor};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  overflow-x: ${({ recentProduct }) => recentProduct && "scroll"};
  overflow-y: ${({ recentProduct }) => recentProduct && "hidden"};
  gap: ${({ gap }) => (gap ? gap : "0")};

  @media ${device.tabletL} {
    display: ${({ hideMobile }) => (hideMobile ? "none" : "flex")};
    height: auto;
  }
  @media ${device.mobileL} {
    margin: ${({ marginMobile }) => marginMobile};
  }

  ${({ recentProduct }) =>
    recentProduct
      ? css`
          ::-webkit-scrollbar {
            display: none;
          }
        `
      : css`
          ::-webkit-scrollbar {
            width: 7px;
            height: 7px;
          }
        `}

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;

const WrapperRowDesc = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  -webkit-box-align: center;
  align-items: start;
  position: relative;
  flex-direction: row;
  margin: 0px 0px 8px;
`;

const WrapperRowDetail = styled.div`
  width: auto;
  height: auto;
  margin-left: 25px;
`;

const TextDetail = styled.span`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 21px;
  color: rgb(37, 37, 37);
  display: block;
`;

const SpanUnit = styled.span`
  font-weight: 450;
  font-size: 0.875rem;
  line-height: 21px;
  color: #6c6c70;
  display: block;

  margin: auto 8px;

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const WrapperRowSumTotal = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  flex-direction: row;
`;

const TextQuantity = styled.span`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 18px;
  color: rgb(37, 37, 37);
  margin-left: 15px;
`;

const TextPriceTotal = styled.span`
  font-family: Prompt;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 25px;
  color: rgb(225, 59, 48);
`;

const TextCurrency = styled.span`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 21px;
  color: rgb(37, 37, 37);
  margin-left: 8px;
`;

const WrapperAddtoCart = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 30px 0px 0px;
  position: relative;
  flex-direction: row;
`;

const ButtonAddToCart = styled.button`
  border-radius: 24px;
  width: 48%;
  height: 56px;
  text-align: center;
  cursor: pointer;
  background: #f7cecb;
  border: 1px solid #d9d9d9;
  font-family: Prompt;
  font-weight: 400;
  font-size: 1rem;
  line-height: 18px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  color: rgb(225, 59, 48);
  transition: all 0.3s ease 0s;
`;

const ButtyonBuyNow = styled.button`
  width: 48%;
  height: 56px;
  border: none;
  cursor: pointer;
  background: rgb(225, 59, 48);
  border-radius: 24px;
  color: rgb(255, 255, 255);
  position: absolute;
  right: 0px;
  font-weight: 500;
  font-size: 1rem;
  line-height: 24px;
  transition: all 0.3s ease 0s;
  font-family: Prompt;
`;

const WrapperImage = styled.div`
  width: 100%;
  max-width: 480px;
`;

const WrapperImagePreview = styled.div`
  width: 100%;
  padding-top: 89.2%;
  position: relative;
  margin-bottom: 25px;
  display: flex;
  justify-content: flex-end;
`;

const WrapperOtherImage = styled.div`
  width: 100%;
  padding-top: 24%;
  justify-content: flex-end;
  position: relative;
  display: flex;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const RowOtherImage = styled.div`
  width: 100%;
  max-width: 480px;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  position: absolute;
  top: 0;
  transition: 0.3s;

  ::-webkit-scrollbar {
    width: 0;
  }
`;

const WrapperDetail = styled.div`
  width: 100%;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 24px;
  padding: 0 24px 24px 24px;
`;

const WrapperTab = styled.div`
  width: 100%;
  display: flex;
  padding: 0 24px;
`;

const WrapperContent = styled.div`
  width: 100%;
  padding: 16px 0;
  /* border: 1px solid rgb(217, 217, 217); */
  border-radius: 0px 0px 24px 24px;
  display: block;
  white-space: pre-line;
  word-break: break-all;

  h3 {
    display: block;
    font-size: 1.25rem;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold !important;
  }
  p {
    word-break: break-all;
    font-size: 1rem;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
`;

const ButtonTab = styled.button`
  width: 50%;
  height: 62px;
  outline: none;
  font-family: Prompt;
  font-weight: ${({ tab, name }) => (tab === name ? "500" : "400")};
  font-size: 1rem;
  line-height: 24px;
  color: ${({ tab, name }) => (tab === name ? "#e13b30" : "rgb(37, 37, 37)")};
  cursor: pointer;
  background: transparent;
  border-image: initial;
  transition: all 0.3s ease 0s;
  border: none;
  border-bottom: ${({ tab, name }) =>
    tab === name ? "3px solid #e13b30" : "1px solid rgb(217, 217, 217)"};
`;

const WrapperKeyWord = styled.div`
  width: 100%;
  display: block;
`;

const Keyword = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 24px;
  color: rgb(37, 37, 37);
  display: flex;
  -webkit-box-align: center;
  align-items: center;

  /* ::before {
    content: '';
    width: 4px;
    color: rgb(225, 59, 48);
    background: rgb(225, 59, 48);
    display: inline-block;
    height: 32px;
    margin-right: 15px;
    border-radius: 3px;
  } */
`;

const WrapperHastag = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  position: relative;
  flex-flow: wrap;
`;

const ImageOther = styled.div`
  width: 100%;
  height: 100%;
  max-width: 105px;
  max-height: 105px;
  position: relative;
  display: block;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgb(217, 217, 217);

  :last-child {
    margin-right: 0;
  }
`;

export const ButtonSlideImage = styled.button`
  width: 30px;
  height: 30px;
  background: transparent;
  border-radius: 16px;
  border: none;
  position: absolute;
  top: 50%;
  left: ${({ left }) => left && "-35px"};
  right: ${({ right }) => right && "-35px"};
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`;

const ButtonOptionsProduct = styled.button`
  width: 36px;
  height: 36px;
  background: rgb(255, 255, 255);
  backdrop-filter: blur(3px);
  border-radius: 8px;
  border: 1px solid rgb(217, 217, 217);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 3px 15px;
  margin-bottom: 15px;
  position: relative;
  transition: 0.3s;

  > svg {
    position: absolute;
    z-index: 1;
  }

  :hover {
    transition: 0.3s;
    padding: 3px 17px;
    width: 100%;

    :last-child {
      width: 185px;
      border-radius: 8px 8px 0 0;
      box-shadow: 1px 1px 3px rgb(0, 0, 0, 0.1);
    }

    > svg {
      position: relative;
      margin-right: 10px;
    }
    > span {
      visibility: visible;
    }

    & > .panel-options-share {
      width: 100%;
      visibility: visible;
      padding: 15px;
      transition: 0.3s;

      & > * {
        visibility: visible;
      }
    }
  }

  :last-child {
    margin-bottom: 0;
  }
`;

const TextButtonShare = styled.span`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 18px;
  color: rgb(225, 59, 48);
  overflow: hidden;
  white-space: nowrap;
  visibility: hidden;
  font-family: Prompt;
`;

const PanelOptionsShare = styled.div`
  width: 0px;
  background: #ffffff;
  box-shadow: 1px 1px 3px rgb(0, 0, 0, 0.1);
  border-radius: 0 0 8px 8px;
  position: absolute;
  top: 35px;
  right: 0;
  visibility: hidden;
  padding: 15px 0;
  outline: 1px solid #d9d9d9;

  & > * {
    visibility: hidden;
    overflow: hidden;
    white-space: nowrap;
    visibility: hidden;
  }
`;

const DivImageAndTextShare = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #252525;

  :last-child {
    margin-bottom: 0;
  }

  :hover {
    > span {
      color: #e13b30;
    }
  }
`;

const TextDetailOptionsShare = styled.span`
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #252525;
  font-family: Prompt;
`;

const DivBtShareIcon = styled.div`
  margin-right: 5px;
  padding: 0px;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
`;

const DivIconShare = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("${(props) => props.img}");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  object-fit: cover;
`;

export const WrapperFeature = styled.div`
  width: 100%;
  height: auto;
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
`;

export const TextFeature = styled.div`
  min-width: 50px;
  height: inherit;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 24px;
  text-align: center;
  color: #e13b30;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.mobileL} {
    white-space: nowrap;
  }
`;

export const Feature = styled.div`
  min-height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d9d9d9;
  cursor: pointer;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  :last-child {
    border-right: none;
  }
`;

export const FeatureScroll = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;

  &::-webkit-scrollbar-track {
    background: transparent;
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media ${device.mobile} {
    justify-content: flex-start;
  }
`;

const WrapperProductType = styled.div`
  display: flex;
  margin: 5px 0px 0px;
  height: auto;
`;

const ProductType = styled.span`
  font-weight: 450;
  font-size: 0.875rem;
  color: rgb(108, 108, 112);
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const ProductUsage = styled.div`
  color: #252525;
  font-family: "Prompt";
  font-size: 1rem;
  font-weight: 500;
  line-height: 24px;
`;

const CalAreaHead = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const QuantityHead = styled.div`
  font-size: 0.875rem;
  display: block;
  font-weight: 500;
  line-height: 24px;
  min-width: 78px;
  color: #252525;
`;

const GroupQuantity = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

const PropertyWrapper = styled.div`
  padding: 16px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const TextPropertyHead = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 24px;
  min-width: 240px;
`;

const TextPropertyDetail = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
`;

const TabDescription = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 0 0px 24px 24px;
  display: block;
  white-space: pre-line;
  word-break: break-all;
`;

const SellerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SellerLogo = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
  margin: auto;
`;

const SellerName = styled.div`
  font-size: 1rem;
  color: #252525;
  font-weight: 500;
  margin-bottom: 16px;
  line-height: 20px;
`;

const SellerLogoAndNameWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  gap: 16px;
`;

const SellerNameStartOnWrapper = styled.div``;

const SellerStartOn = styled.div`
  font-size: 0.875rem;
  color: #252525;
  font-weight: 400;
  line-height: 24px;
`;

const SellerContactWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SellerTel = styled.button`
  width: 160px;
  padding: 8px 16px;
  height: 40px;
  align-items: center;
  display: flex;
  text-align: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.875rem;
  color: #e13b30;
  border: 1px solid #e13b30;
  border-radius: 8px;
  background: transparent;
  margin: 0 8px;
  cursor: pointer;
`;

const SellerLine = styled.button`
  width: 160px;
  padding: 8px 16px;
  height: 40px;
  align-items: center;
  display: flex;
  text-align: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.875rem;
  color: #e13b30;
  border: 1px solid #e13b30;
  border-radius: 8px;
  background: transparent;
  margin: 0 8px;
  cursor: pointer;
`;

const SellerContactDescription = styled.div`
  margin-top: 24px;
  display: flex;
  width: 100%;
  justify-content: center;
  text-align: center;
  font-weight: 400;
  font-size: 1rem;
  text-decoration-line: underline;
  color: #e13b30;
  cursor: pointer;
`;

const ButtonLineDeal = styled.button`
  width: 100%;
  margin: 16px 0 4px 0;
  height: 56px;
  border: 1px solid rgb(90, 195, 99);
  cursor: pointer;
  background: white;
  font-weight: 500;
  border-radius: 24px;
  color: ${({ color }) => (color ? color : "rgb(90, 195, 99)")};
  line-height: 24px;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : null};
`;

const TextAnnounce = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 20px;
`;

const TextStockStatus = styled.div`
  color: rgb(231, 137, 0);
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  min-width: 86px;
`;

export const DiscountWrapper = styled.div`
  width: 40px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 15px;
`;

export const DiscountPercent = styled.span`
  position: absolute;
  font-size: 0.625rem;
  color: white;
`;

export const WrapperTag = styled.div`
  width: auto;
  position: absolute;
  gap: 5px;
  display: flex;
  flex-direction: column;
  right: 0;
  padding-top: 5px;
`;

export const WrapperXclusiveDeal = styled.div`
  display: flex;
  align-items: start;
`;

const ProductDetail = ({ dataUpload, dataUploadChoice }) => {
  const [productChoice, setProductChoice] = useState(0);
  const [buttonSlide, setButtonSlide] = useState(false);
  const [isShowUsage, setIsShowUsage] = useState(false);
  const [tab, setTab] = useState("description");

  const mainImage = (data) => {
    const image = [];

    if (!!data?.group_image?.product_display_image) {
      image.push(
        <ImageMain
          id="product_display_image"
          className="main-image"
          key={image.length}
        >
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_display_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_display_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_display_image?.fileData
            }
          />
          {/* {products?.reduce_percent > 0 && products?.reduce_percent < 100 && (
            <LabelDiscountMobile>
              -{products?.reduce_percent}%
            </LabelDiscountMobile>
          )} */}
        </ImageMain>,
      );
    }
    if (!!data?.group_image?.product_full_image) {
      image.push(
        <ImageMain
          id="product_full_image"
          className="main-image"
          key={image.length}
        >
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_full_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_full_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_full_image?.fileData
            }
          />
          {/* {products?.reduce_percent > 0 && products?.reduce_percent < 100 && (
            <LabelDiscountMobile>
              -{products?.reduce_percent}%
            </LabelDiscountMobile>
          )} */}
        </ImageMain>,
      );
    }
    if (!!data?.group_image?.product_closeup_image) {
      image.push(
        <ImageMain
          id="product_closeup_image"
          className="main-image"
          key={image.length}
        >
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_closeup_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_closeup_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_closeup_image?.fileData
            }
          />
        </ImageMain>,
      );
    }
    if (!!data?.group_image?.product_other1_image) {
      image.push(
        <ImageMain id="image-1" className="main-image" key={image.length}>
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_other1_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_other1_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_other1_image?.fileData
            }
          />
        </ImageMain>,
      );
    }

    if (!!data?.group_image?.product_other2_image) {
      image.push(
        <ImageMain id="image-2" className="main-image" key={image.length}>
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_other2_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_other2_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_other2_image?.fileData
            }
          />
        </ImageMain>,
      );
    }
    if (!!data?.group_image?.product_other3_image) {
      image.push(
        <ImageMain id="image-3" className="main-image" key={image.length}>
          <MainImageStyled
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_other3_image === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_other3_image?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image
                    ?.product_other3_image?.fileData
            }
          />
        </ImageMain>,
      );
    }

    if (!!data?.group_image?.product_video) {
      image.push(
        <DivVideo id="image-5" className="main-image" key={image.length}>
          <VideoMain
            style={{ opacity: 0.7 }}
            src={
              typeof dataUploadChoice[productChoice]?.group_image
                ?.product_video === "string"
                ? dataUploadChoice[
                    productChoice
                  ]?.group_image?.product_video?.replace(
                    "https://productimage.xsurface.com/",
                    "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                  )
                : dataUploadChoice[productChoice]?.group_image?.product_video
                    ?.fileData
            }
            controls
            autoPlay="autoplay"
            preLoad="auto"
            muted
            type="video/mp4"
          >
            <source
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_video === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_video.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image?.product_video
                      ?.fileData
              }
              type="video/mp4"
            />
          </VideoMain>
        </DivVideo>,
      );
    }

    return image;
  };

  const imageSecondary = (data) => {
    const image = [];

    if (
      !!data?.group_image?.product_display_image &&
      data?.group_image?.product_display_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other active"
          key={`product_display_image`}
          onClick={(event) => selectMainImage(event, "product_display_image")}
        >
          <ImageOther>
            <ImageSecondary
              // className="second-image"
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_display_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_display_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_display_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }
    if (
      !!data?.group_image?.product_full_image &&
      data?.group_image?.product_full_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other active"
          key={`product_full_image`}
          onClick={(event) => selectMainImage(event, "product_full_image")}
        >
          <ImageOther>
            <ImageSecondary
              // className="second-image"
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_full_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_full_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_full_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }

    if (
      !!data?.group_image?.product_closeup_image &&
      data?.group_image?.product_closeup_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other"
          key={`product_closeup_image`}
          onClick={(event) => selectMainImage(event, "product_closeup_image")}
        >
          <ImageOther>
            <ImageSecondary
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_closeup_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_closeup_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_closeup_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }

    if (
      !!data?.group_image?.product_other1_image &&
      data?.group_image?.product_other1_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other"
          key={`product_other1_image`}
          onClick={(event) => selectMainImage(event, "image-1")}
        >
          <ImageOther>
            <ImageSecondary
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_other1_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_other1_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_other1_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }
    if (
      !!data?.group_image?.product_other2_image &&
      data?.group_image?.product_other2_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other"
          key={`product_other2_image`}
          onClick={(event) => selectMainImage(event, "image-2")}
        >
          <ImageOther>
            <ImageSecondary
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_other2_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_other2_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_other2_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }
    if (
      !!data?.group_image?.product_other3_image &&
      data?.group_image?.product_other3_image !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other"
          key={`product_other3_image`}
          onClick={(event) => selectMainImage(event, "image-3")}
        >
          <ImageOther>
            <ImageSecondary
              key={image.length}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_other3_image === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_other3_image?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image
                      ?.product_other3_image?.fileData
              }
            />
          </ImageOther>
        </DivImageSecondary>,
      );
    }

    if (
      !!data?.group_image?.product_video &&
      data?.group_image?.product_video !== "null"
    ) {
      image.push(
        <DivImageSecondary
          className="image-other"
          key={`product_video`}
          onClick={(event) => selectMainImage(event, "image-5")}
        >
          <ImageOther>
            <VideoSecondary
              style={{ opacity: 0.7 }}
              src={
                typeof dataUploadChoice[productChoice]?.group_image
                  ?.product_video === "string"
                  ? dataUploadChoice[
                      productChoice
                    ]?.group_image?.product_video?.replace(
                      "https://productimage.xsurface.com/",
                      "https://product-xsurface.s3.ap-southeast-1.amazonaws.com/",
                    )
                  : dataUploadChoice[productChoice]?.group_image?.product_video
                      ?.fileData
              }
            />

            <WrapperBlackground>
              <BGCollection />
              <PlayVideoSecondaryOnVideo />
            </WrapperBlackground>
          </ImageOther>
        </DivImageSecondary>,
      );
    }

    return image;
  };

  const selectMainImage = (evt, image) => {
    let i, mainImage, secondImage;
    mainImage = document.getElementsByClassName("main-image");
    for (i = 0; i < mainImage.length; i++) {
      mainImage[i].style.display = "none";
    }
    secondImage = document.getElementsByClassName("image-other");

    for (i = 0; i < secondImage.length; i++) {
      if (secondImage[i].contains(evt.target))
        secondImage[i].classList.add("active");
      else secondImage[i].classList.remove("active");
    }
    document.getElementById(image).style.display = "block";
  };

  const handleResetMainImage = () => {
    let mainImage = document.getElementsByClassName("main-image");
    for (let i = 0; i < mainImage.length; i++) {
      if (i === 0) {
        mainImage[i].style.display = "block";
      } else {
        mainImage[i].style.display = "none";
      }
    }

    let secondImage = document.getElementsByClassName("image-other");
    for (let i = 0; i < secondImage.length; i++) {
      if (i === 0) {
        secondImage[i].classList.add("active");
      } else {
        secondImage[i].classList.remove("active");
      }
    }
  };

  const convertIntToCurrency = (int = 0, isDecimal = true) => {
    const convertFormat = (Math.round(int * 100) / 100).toLocaleString();
    const currency = `${convertFormat}.${
      (Math.round(int * 100) / 100).toFixed(2).split(".")[1]
    }`;

    if (String(int).split(".").length > 1) {
      return isDecimal
        ? (Math.round(int * 100) / 100).toLocaleString()
        : (Math.round(int * 100) / 100).toLocaleString().split(".").shift();
    }

    return isDecimal ? currency : currency.split(".").shift();
  };

  useEffect(() => {
    let imageQuantity = document.getElementsByClassName("image-other").length;
    if (imageQuantity > 4) {
      setButtonSlide(true);
    } else {
      setButtonSlide(false);
    }
  }, [dataUploadChoice]);

  // console.log({ dataUpload, dataUploadChoice });

  return (
    <>
      <DivProductDetail>
        <DivImageMain>
          <WrapperImage>
            <WrapperImagePreview>
              {mainImage(dataUploadChoice[productChoice])}

              {dataUploadChoice[productChoice]?.reduce_percent &&
              dataUploadChoice[productChoice]?.reduce_percent > 0 &&
              dataUploadChoice[productChoice]?.reduce_percent < 100 ? (
                <DiscountWrapper>
                  <IconDiscountTag />
                  <DiscountPercent>
                    {`-${dataUploadChoice[productChoice]?.reduce_percent}%`}
                  </DiscountPercent>
                </DiscountWrapper>
              ) : null}

              <FeatureProduct>
                <ButtonOptionsProduct>
                  <IconDownload width={18} height={18} fill={"#e13b30"} />
                  <TextButtonShare>ดาวน์โหลดรูปภาพขนาดเต็ม</TextButtonShare>
                </ButtonOptionsProduct>

                <ButtonOptionsProduct className="share-button">
                  <IconShare
                    className="icon-share"
                    width={24}
                    height={24}
                    fill={"#e13b30"}
                  />
                  <TextButtonShare>แบ่งปัน</TextButtonShare>

                  <PanelOptionsShare className="panel-options-share">
                    <DivImageAndTextShare>
                      <IconCopyLink style={{ margin: "0 12px 0 5px" }} />
                      <TextDetailOptionsShare>
                        คัดลอกลิ้งค์
                      </TextDetailOptionsShare>
                    </DivImageAndTextShare>

                    <DivImageAndTextShare>
                      <DivBtShareIcon>
                        <DivIconShare img="https://image.xsurface.com/icon/icon_facebook_normal.png" />
                      </DivBtShareIcon>
                      <TextDetailOptionsShare>
                        แชร์ไปยัง Facebook
                      </TextDetailOptionsShare>
                    </DivImageAndTextShare>

                    <DivImageAndTextShare>
                      <DivBtShareIcon>
                        <DivIconShare img="https://image.xsurface.com/icon/icon_line_normal.png" />
                      </DivBtShareIcon>
                      <TextDetailOptionsShare>
                        แชร์ไปยัง Line
                      </TextDetailOptionsShare>
                    </DivImageAndTextShare>
                  </PanelOptionsShare>
                </ButtonOptionsProduct>
              </FeatureProduct>
            </WrapperImagePreview>

            <WrapperOtherImage>
              <RowOtherImage id="other-image">
                {imageSecondary(dataUploadChoice[productChoice])}
              </RowOtherImage>

              {buttonSlide && (
                <>
                  <ButtonSlideImage
                    left
                    onClick={() => {
                      let scrollWidth =
                        document.getElementById("other-image").scrollLeft;
                      document.getElementById("other-image").scroll({
                        top: 0,
                        left: scrollWidth - 405,
                        behavior: "smooth",
                      });
                    }}
                  >
                    <IconArrowDown
                      color="#E13B30"
                      style={{ transform: "rotate(90deg)" }}
                    />
                  </ButtonSlideImage>

                  <ButtonSlideImage
                    right
                    onClick={() => {
                      let scrollWidth =
                        document.getElementById("other-image").scrollLeft;
                      document.getElementById("other-image").scroll({
                        top: 0,
                        left: scrollWidth + 405,
                        behavior: "smooth",
                      });
                    }}
                  >
                    <IconArrowDown
                      color="#E13B30"
                      style={{ transform: "rotate(-90deg)" }}
                    />
                  </ButtonSlideImage>
                </>
              )}
            </WrapperOtherImage>
          </WrapperImage>

          <WrapperFeature>
            <FeatureScroll>
              <Feature material>
                <IconMaterialAlbumNew
                  width={17}
                  height={17}
                  color={"#E13B30"}
                  style={{
                    marginRight: "7px",
                    minWidth: "16px",
                    minHeight: "16px",
                  }}
                />

                <TextFeature>บันทึกลงอัลบั้ม</TextFeature>
              </Feature>

              <Feature sample>
                <IconSampleRequest
                  width={24}
                  height={25}
                  fill="#E13B30"
                  style={{
                    marginRight: "4px",
                  }}
                  sample
                />
                <TextFeature sample>ขอสินค้าตัวอย่าง</TextFeature>
              </Feature>

              <Feature stroke compare>
                <IconCompare
                  width={17}
                  height={20}
                  fill={"#E13B30"}
                  style={{
                    marginRight: "7px",
                    minWidth: "16px",
                    minHeight: "16px",
                  }}
                />
                <TextFeature compareProduct>เปรียบเทียบสินค้า</TextFeature>
              </Feature>
            </FeatureScroll>
          </WrapperFeature>
        </DivImageMain>

        <DivDescription>
          <WrapperImageSecondary>
            <ProductDetailWrapper>
              <WrapperProductName>
                <ProductName>{dataUpload?.item_name}</ProductName>

                <WrapperTag>
                  {dataUploadChoice[productChoice]?.is_deal ? (
                    <WrapperXclusiveDeal>
                      <IconExclusiveDealBlack />
                    </WrapperXclusiveDeal>
                  ) : null}

                  {dataUpload?.is_installer && (
                    <LabelIsInstaller>
                      <WrapperIconInstaller>
                        <IconInstaller width="100%" height="100%" />
                      </WrapperIconInstaller>

                      <RowDescription flexDirection="column">
                        <TextHeadInstall>มีช่าง</TextHeadInstall>
                        <TextDescInstall>บริการติดตั้ง</TextDescInstall>
                      </RowDescription>
                    </LabelIsInstaller>
                  )}
                </WrapperTag>
              </WrapperProductName>

              <WrapperProductCode>
                <ProductCode>{dataUpload?.item_code}</ProductCode>
              </WrapperProductCode>

              <WrapperProductType>
                <ProductType>
                  {dataUpload?.product_types
                    ?.map((item) => item.type_th.trim())
                    .join(", ")}
                </ProductType>
              </WrapperProductType>

              {dataUploadChoice[productChoice]?._id !== null &&
              dataUploadChoice[productChoice]?.group_price?.start_price === 0 &&
              dataUploadChoice[productChoice]?.group_price?.price === 0 &&
              dataUploadChoice[productChoice]?.group_price?.special_price ===
                0 ? (
                <WrapperProductPrice>
                  <ProductPrice3>สอบถามเพิ่มเติม</ProductPrice3>
                </WrapperProductPrice>
              ) : dataUploadChoice[productChoice]?.group_price
                  ?.is_start_price ? (
                <>
                  <WrapperProductPrice>
                    <ProductPrice3>ราคาเริ่มต้นที่</ProductPrice3>
                    <ProductPrice>
                      ฿
                      {
                        dataUploadChoice[productChoice]?.group_price
                          ?.start_price
                      }
                    </ProductPrice>
                    <ProductPrice2>
                      {`/${dataUploadChoice[productChoice]?.group_price?.unit_price?.unit_th}`}
                    </ProductPrice2>
                  </WrapperProductPrice>

                  <WrapperPriceVat>
                    <PriceVat>
                      *ราคานี้ไม่รวมค่าติดตั้ง / *ราคานี้ยังไม่รวม Vat 7 %
                    </PriceVat>
                  </WrapperPriceVat>
                </>
              ) : dataUploadChoice[productChoice]?.group_price
                  ?.special_price === 0 &&
                dataUploadChoice[productChoice]?.group_price?.price === 0 ? (
                <>
                  <DivFlex>
                    <ProductPrice3>สอบถามเพิ่มเติม</ProductPrice3>
                  </DivFlex>
                </>
              ) : dataUploadChoice[productChoice]?.group_price?.special_price <
                  dataUploadChoice[productChoice]?.group_price?.price &&
                dataUploadChoice[productChoice]?.group_price?.special_price !==
                  0 &&
                dataUploadChoice[productChoice]?.group_price?.special_price !==
                  null ? (
                <>
                  <WrapperProductPrice>
                    <ProductPrice>
                      {`฿${convertIntToCurrency(
                        dataUploadChoice[productChoice]?.group_price
                          ?.special_price,
                      )}`}
                    </ProductPrice>
                    <ProductPrice2 specialprice={false}>
                      {
                        <>
                          บาท/
                          {
                            dataUploadChoice[productChoice]?.group_price
                              ?.unit_price.unit_th
                          }
                        </>
                      }
                    </ProductPrice2>
                  </WrapperProductPrice>

                  <WrapperSpecialPrice>
                    <ProductPriceSpecial>
                      {`฿${convertIntToCurrency(
                        dataUploadChoice[productChoice]?.group_price?.price,
                      )}`}
                    </ProductPriceSpecial>
                  </WrapperSpecialPrice>

                  <WrapperPriceVat>
                    <PriceVat>
                      *ราคานี้ไม่รวมค่าติดตั้ง / *ราคานี้ยังไม่รวม Vat 7 %
                    </PriceVat>
                  </WrapperPriceVat>
                </>
              ) : (
                !!dataUploadChoice[productChoice]?.group_price?.price && (
                  <>
                    <WrapperProductPrice>
                      <ProductPrice>
                        {`฿${convertIntToCurrency(
                          dataUploadChoice[productChoice]?.group_price?.price,
                        )}`}
                      </ProductPrice>

                      <ProductPrice2 specialprice={false}>
                        บาท/
                        {
                          dataUploadChoice[productChoice]?.group_price
                            ?.unit_price.unit_th
                        }
                      </ProductPrice2>
                    </WrapperProductPrice>

                    <WrapperPriceVat>
                      <PriceVat>
                        *ราคานี้ไม่รวมค่าติดตั้ง / *ราคานี้ยังไม่รวม Vat 7 %
                      </PriceVat>
                    </WrapperPriceVat>
                  </>
                )
              )}

              <LineSectionDetail />

              {dataUploadChoice.length > 1 && (
                <WrapperOptionsProduct>
                  <OptionsProduct>ตัวเลือกสินค้า</OptionsProduct>
                </WrapperOptionsProduct>
              )}

              {dataUploadChoice.length > 1 && (
                <RowDescription padding="8px 0" flexWrap="wrap">
                  {dataUploadChoice.map((choice, index) => (
                    <ProductOption
                      isActive={
                        choice?._id === dataUploadChoice[productChoice]?._id
                      }
                      isStock={choice?.is_instock}
                      onClick={() => {
                        handleResetMainImage();
                        setProductChoice(index);
                      }}
                    >
                      {choice?.name}
                    </ProductOption>
                  ))}
                </RowDescription>
              )}

              {/* Brand */}
              {dataUpload?.brand?.name && (
                <WrapperRowDesc>
                  <OptionsProduct>แบรนด์</OptionsProduct>

                  <WrapperRowDetail>
                    <TextDetail>{dataUpload?.brand?.name}</TextDetail>
                  </WrapperRowDetail>
                </WrapperRowDesc>
              )}

              {/* Color */}
              {dataUploadChoice[productChoice]?.color?.color_th && (
                <WrapperRowDesc>
                  <OptionsProduct>สี</OptionsProduct>

                  <WrapperRowDetail>
                    <TextDetail>
                      {dataUploadChoice[productChoice]?.color?.color_th}
                    </TextDetail>
                  </WrapperRowDetail>
                </WrapperRowDesc>
              )}

              {/* Pattern */}
              {dataUploadChoice[productChoice]?.pattern?.pattern_th && (
                <WrapperRowDesc>
                  <OptionsProduct>ลวดลาย</OptionsProduct>

                  <WrapperRowDetail>
                    <TextDetail>
                      {dataUploadChoice[productChoice]?.pattern?.pattern_th}
                    </TextDetail>
                  </WrapperRowDetail>
                </WrapperRowDesc>
              )}

              {/* Texture */}
              {dataUploadChoice[productChoice]?.texture_type?.type_th && (
                <WrapperRowDesc>
                  <OptionsProduct>ผิวสัมผัส</OptionsProduct>

                  <WrapperRowDetail>
                    <TextDetail>
                      {dataUploadChoice[productChoice]?.texture_type?.type_th}
                    </TextDetail>
                  </WrapperRowDetail>
                </WrapperRowDesc>
              )}

              {/* Size */}

              {dataUploadChoice[productChoice]?.size?.width &&
                dataUploadChoice[productChoice]?.size?.height &&
                dataUploadChoice[productChoice]?.size?.thickness && (
                  <WrapperRowDesc>
                    {/* Size */}
                    <OptionsProduct>ขนาด</OptionsProduct>

                    <WrapperRowDetail>
                      {
                        //initial value
                        <TextDetail>
                          {dataUploadChoice?.length > 0 &&
                          dataUploadChoice[productChoice]?.size?.width
                            ? `${
                                dataUploadChoice[productChoice]?.size?.width
                                  ? dataUploadChoice[productChoice]?.size?.width
                                  : ""
                              }
                ${
                  dataUploadChoice[productChoice]?.size?.unit_width?.unit_th
                    ? dataUploadChoice[productChoice]?.size?.unit_width?.unit_th
                    : ""
                } ${dataUploadChoice[productChoice]?.size?.width ? "x" : ""}
                ${
                  dataUploadChoice[productChoice]?.size?.height
                    ? dataUploadChoice[productChoice]?.size?.height
                    : ""
                }
                ${
                  dataUploadChoice[productChoice]?.size?.unit_height?.unit_th
                    ? dataUploadChoice[productChoice]?.size?.unit_height
                        ?.unit_th
                    : ""
                } ${dataUploadChoice[productChoice]?.size?.height ? "x" : ""} ${
                  dataUploadChoice[productChoice]?.size?.thickness
                    ? dataUploadChoice[productChoice]?.size?.thickness
                    : "-"
                } ${
                  dataUploadChoice[productChoice]?.size?.unit_thickness?.unit_th
                    ? dataUploadChoice[productChoice]?.size?.unit_thickness
                        ?.unit_th
                    : ""
                }`
                            : `${
                                dataUploadChoice[productChoice]?.size
                                  ?.capacity_size
                              } ${
                                dataUploadChoice[productChoice]?.size
                                  ?.unit_capacity?.unit_th
                                  ? dataUploadChoice[productChoice]?.size
                                      ?.unit_capacity?.unit_th
                                  : ""
                              }`}
                        </TextDetail>
                      }
                    </WrapperRowDetail>
                  </WrapperRowDesc>
                )}

              <LineSectionDetail />

              <RowDescription
                alignItems="center"
                justifyContent="space-between"
                cursor="pointer"
                onClick={() => setIsShowUsage(!isShowUsage)}
              >
                <ProductUsage>การใช้งาน</ProductUsage>

                <IconArrowDown
                  style={{
                    transform: isShowUsage && "rotate(180deg)",
                    transition: "0.3s",
                  }}
                />
              </RowDescription>

              {isShowUsage && (
                <>
                  <RowDescription
                    justifyContent="space-between"
                    margin="16px 0px 8px 0px"
                    alignItems="center"
                  >
                    <WrapperRowDesc>
                      <OptionsProduct>สถานที่ใช้งาน</OptionsProduct>

                      <WrapperRowDetail>
                        <TextDetail>
                          {dataUpload?.suitable_areas
                            ?.map((item) =>
                              item.area_th ? item.area_th.trim() : "-",
                            )
                            .filter((item) => item !== "-")
                            .join(", ") || "-"}
                        </TextDetail>
                      </WrapperRowDetail>
                    </WrapperRowDesc>
                  </RowDescription>

                  <RowDescription
                    justifyContent="space-between"
                    margin="8px 0px 8px 0px"
                    alignItems="center"
                  >
                    <WrapperRowDesc>
                      <OptionsProduct>พื้นที่ใช้งาน</OptionsProduct>

                      <WrapperRowDetail>
                        <TextDetail>
                          {dataUpload?.recommend_rooms
                            ?.map((item) =>
                              item.room_th ? item.room_th.trim() : "-",
                            )
                            .filter((item) => item !== "-")
                            .join(", ") || "-"}
                        </TextDetail>
                      </WrapperRowDetail>
                    </WrapperRowDesc>
                  </RowDescription>
                </>
              )}

              <LineSectionDetail />

              {!!dataUploadChoice[productChoice]?.size && (
                <RowDescription
                  alignItems="center"
                  justifyContent="space-between"
                  cursor="pointer"
                >
                  <CalAreaHead
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <IconCalculationArea />
                    <ProductUsage>คำนวณพื้นที่</ProductUsage>
                  </CalAreaHead>

                  <IconArrowDown />
                </RowDescription>
              )}

              <LineSectionDetail />

              {!dataUploadChoice[productChoice]?.group_price
                ?.is_start_price && (
                <>
                  <RowDescription>
                    <QuantityHead>จำนวน</QuantityHead>
                  </RowDescription>
                  <RowDescription
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <GroupQuantity>
                      <IconReduceButton
                        style={{ minWidth: "40px", cursor: "pointer" }}
                      />
                      <InputVolume
                        value={
                          dataUpload?.min_order_qty > 1
                            ? dataUpload?.min_order_qty
                            : 1
                        }
                      />
                      <IconAddButton
                        style={{ minWidth: "40px", cursor: "pointer" }}
                      />
                      <SpanUnit>
                        {`${
                          !!dataUploadChoice[productChoice]?.group_price
                            ?.unit_price &&
                          dataUploadChoice[productChoice]?.group_price
                            ?.unit_price?.unit_th
                        }`}
                      </SpanUnit>
                    </GroupQuantity>

                    {!dataUploadChoice[productChoice]?.is_instock ? (
                      <TextStockStatus>สอบถามสต๊อก</TextStockStatus>
                    ) : null}
                  </RowDescription>
                  {dataUpload?.min_order_qty > 1 && (
                    <RowDescription margin="12px 0px 0px 0px">
                      <TextDetail>{`*จำนวนการสั่งซื้อขั้นต่ำ: ${dataUpload?.min_order_qty}`}</TextDetail>
                    </RowDescription>
                  )}

                  <LineSectionDetail />
                </>
              )}

              {!dataUploadChoice[productChoice]?.group_price
                ?.is_start_price && (
                <WrapperRowSumTotal>
                  <OptionsProduct>
                    ราคารวม
                    <TextQuantity>{`(1 ${dataUploadChoice[productChoice]?.group_price?.unit_price?.unit_th})`}</TextQuantity>
                  </OptionsProduct>

                  <div>
                    {
                      <TextPriceTotal>
                        {`${convertIntToCurrency(
                          dataUploadChoice[productChoice]?.group_price
                            ?.special_price
                            ? dataUploadChoice[productChoice]?.group_price
                                ?.special_price
                            : dataUploadChoice[productChoice]?.group_price
                                  ?.start_price
                              ? dataUploadChoice[productChoice]?.group_price
                                  ?.start_price
                              : dataUploadChoice[productChoice]?.group_price
                                  ?.price,
                          true,
                        )}`}
                      </TextPriceTotal>
                    }

                    <TextCurrency>บาท</TextCurrency>
                  </div>
                </WrapperRowSumTotal>
              )}

              {dataUploadChoice[productChoice]?.group_price?.is_start_price ? (
                <>
                  <ButtonLineDeal
                    backgroundColor="rgb(90, 195, 99)"
                    color="white"
                  >
                    <IconLine fill="white" style={{ marginRight: "8px" }} />
                    สอบถามเพิ่มเติม
                  </ButtonLineDeal>
                </>
              ) : !dataUploadChoice[productChoice]?.is_instock ? (
                <>
                  <ButtonLineDeal
                    backgroundColor="rgb(90, 195, 99)"
                    color="white"
                  >
                    <IconLine fill="white" style={{ marginRight: "8px" }} />
                    สอบถามสต๊อก
                  </ButtonLineDeal>
                </>
              ) : (
                <>
                  <WrapperAddtoCart>
                    <ButtonAddToCart>
                      <IconCart
                        style={{ marginRight: "10px" }}
                        width="20"
                        height="20"
                      />
                      เพิ่มลงตะกร้า
                    </ButtonAddToCart>

                    <ButtyonBuyNow>ซื้อเลย</ButtyonBuyNow>
                  </WrapperAddtoCart>
                  <ButtonLineDeal>
                    <IconLine
                      fill="rgb(90, 195, 99)"
                      style={{ marginRight: "8px" }}
                    />
                    สอบถามเพิ่มเติม
                  </ButtonLineDeal>
                  <RowDescription alignItems="center" gap="8px">
                    <IconWarning />
                    <TextAnnounce>
                      {`สอบถามราคาโครงการ/ค่าติดตั้งติดต่อผ่านไลน์`}
                    </TextAnnounce>
                  </RowDescription>
                </>
              )}
            </ProductDetailWrapper>
          </WrapperImageSecondary>
        </DivDescription>
      </DivProductDetail>
      <WrapperDetail>
        <WrapperTab>
          <ButtonTab
            tab={tab}
            name="description"
            onClick={() => setTab("description")}
          >
            รายละเอียดสินค้า
          </ButtonTab>
          <ButtonTab
            tab={tab}
            name="properties"
            onClick={() => setTab("properties")}
          >
            คุณสมบัติสินค้า
          </ButtonTab>
          <ButtonTab tab={tab} name="seller" onClick={() => setTab("seller")}>
            ติดต่อร้านค้า
          </ButtonTab>
        </WrapperTab>

        {tab === "description" && (
          <>
            <WrapperContent
              dangerouslySetInnerHTML={{
                __html: !!dataUpload?.description
                  ? dataUpload?.description
                  : "สินค้านี้ไม่มีรายละเอียด",
              }}
            />
            {dataUploadChoice[productChoice]?.hashtags?.length > 0 && (
              <WrapperKeyWord>
                <Keyword>คำค้นหา</Keyword>

                <WrapperHastag>
                  {dataUploadChoice[productChoice]?.hashtags?.length > 0 &&
                    dataUploadChoice[productChoice]?.hashtags?.map(
                      (list, index) => (
                        <ButtonKeyword key={`hashtag-${index}`}>
                          #{list?.name}
                        </ButtonKeyword>
                      ),
                    )}
                </WrapperHastag>
              </WrapperKeyWord>
            )}
          </>
        )}

        {tab === "properties" && (
          <TabDescription>
            <PropertyWrapper backgroundColor={"#F3F1F2"}>
              <TextPropertyHead>แบรนด์</TextPropertyHead>
              <TextPropertyDetail>{dataUpload?.brand?.name}</TextPropertyDetail>
            </PropertyWrapper>

            <PropertyWrapper>
              <TextPropertyHead>สถานที่ใช้งาน</TextPropertyHead>
              <TextPropertyDetail>
                {dataUpload?.recommend_rooms?.length > 0
                  ? dataUpload?.recommend_rooms
                      ?.map((item) => item.room_th)
                      .join(", ")
                  : "-"}
              </TextPropertyDetail>
            </PropertyWrapper>

            <PropertyWrapper backgroundColor={"#F3F1F2"}>
              <TextPropertyHead>พื้นที่ใช้งาน</TextPropertyHead>
              <TextPropertyDetail>
                {dataUpload?.suitable_areas.length > 0
                  ? dataUpload?.suitable_areas
                      ?.map((item) => item.area_th)
                      .join(", ")
                  : "-"}
              </TextPropertyDetail>
            </PropertyWrapper>

            {dataUpload?.product_features?.length > 0 &&
              dataUpload?.product_features?.map((item, index) => (
                <PropertyWrapper
                  backgroundColor={index % 2 === 0 ? "white" : "#F3F1F2"}
                >
                  <TextPropertyHead>{item.feature_th}</TextPropertyHead>
                  <TextPropertyDetail>✓</TextPropertyDetail>
                </PropertyWrapper>
              ))}
          </TabDescription>
        )}

        {tab === "seller" && (
          <TabDescription>
            <SellerWrapper>
              <SellerLogoAndNameWrapper>
                <SellerLogo src={dataUpload?.user?.seller?.profile_image} />
                <SellerNameStartOnWrapper>
                  <SellerName>
                    {dataUpload?.user?.seller?.company_name}
                  </SellerName>
                  <SellerStartOn>
                    {`เริ่มขายบน XSURFACE `}
                    {dataUpload?.user?.seller?.approve_date
                      ? new Date(
                          dataUpload?.user?.seller?.approve_date,
                        ).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      : new Date(
                          dataUpload?.user?.seller?.createdAt,
                        ).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                  </SellerStartOn>
                </SellerNameStartOnWrapper>
              </SellerLogoAndNameWrapper>

              <SellerContactWrapper>
                <SellerTel>
                  <IconTel style={{ marginRight: "4px" }} />
                  0656562887
                </SellerTel>
                <SellerLine>
                  <IconLine style={{ marginRight: "4px" }} />
                  สอบถามเพิ่มเติม
                </SellerLine>
              </SellerContactWrapper>

              <SellerContactDescription>
                รายละเอียดร้านค้า
              </SellerContactDescription>
            </SellerWrapper>
          </TabDescription>
        )}
      </WrapperDetail>
    </>
  );
};

export default ProductDetail;
